export function ResultsDisclaimer() {
  return (
    <p className="mt-3 text-sm font-normal leading-relaxed text-muted-foreground">
      Results described here are not typical and are not a guarantee of income or production. Individual results vary.
    </p>
  );
}